import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch',
  standalone: true, // Use if you are using Standalone Components (Angular 14+)
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, search: any): SafeHtml {
    if (!value) {
      return value;
    }

    // Extract search term from string or object
    let searchTerm = '';
    if (typeof search === 'string') {
      searchTerm = search;
    } else if (search && typeof search === 'object' && search.name) {
      searchTerm = search.name;
    }

    if (!searchTerm) {
      return value;
    }

    // Escape special characters and create a case-insensitive Regex
    const re = new RegExp(
      searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
      'gi',
    );

    // Wrap matches in a span with a specific class
    const result = value.replace(
      re,
      (match) => `<span class="text-highlight">${match}</span>`,
    );

    // We must sanitize the HTML to tell Angular this dynamic string is safe to render
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
